import { PermissionsManager } from './permission-manager';

export const appPermissions = new PermissionsManager();
